/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const processBooking = /* GraphQL */ `
  mutation ProcessBooking($input: CreateBookingInput!) {
    processBooking(input: $input) {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      customReminder
      attendance
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        eventBooking {
          nextToken
        }
      }
    }
  }
`;
export const processBookingWorkshop = /* GraphQL */ `
  mutation ProcessBookingWorkshop($input: CreateBookingWorkshopInput!) {
    processBookingWorkshop(input: $input) {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      customReminder
      attendance
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        eventBooking {
          nextToken
        }
      }
    }
  }
`;
export const createBatchEventSlot = /* GraphQL */ `
  mutation CreateBatchEventSlot($slots: [CreateEventSlotInput]) {
    createBatchEventSlot(slots: $slots) {
      id
      time
      length
      type
      booked
      isDeleted
      createdAt
      updatedAt
      eventSlotGroup {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        updatedAt
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        eventSlot {
          nextToken
        }
      }
      eventBooking {
        items {
          id
          firstname
          lastname
          email
          mobile
          dob
          customData
          createdAt
          startTime
          twentyFourHourReminder
          fortyEightHourReminder
          customReminder
          attendance
          searchField
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createEventCompany = /* GraphQL */ `
  mutation CreateEventCompany(
    $input: CreateEventCompanyInput!
    $condition: ModelEventCompanyConditionInput
  ) {
    createEventCompany(input: $input, condition: $condition) {
      id
      name
      createdAt
      logo
      logoFileName
      email
      isDeleted
      eventLocationLookup {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      updatedAt
      event {
        items {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventClientAccess {
        items {
          id
          expiryDate
          clientPassword
          showPersonal
          description
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateEventCompany = /* GraphQL */ `
  mutation UpdateEventCompany(
    $input: UpdateEventCompanyInput!
    $condition: ModelEventCompanyConditionInput
  ) {
    updateEventCompany(input: $input, condition: $condition) {
      id
      name
      createdAt
      logo
      logoFileName
      email
      isDeleted
      eventLocationLookup {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      updatedAt
      event {
        items {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventClientAccess {
        items {
          id
          expiryDate
          clientPassword
          showPersonal
          description
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteEventCompany = /* GraphQL */ `
  mutation DeleteEventCompany(
    $input: DeleteEventCompanyInput!
    $condition: ModelEventCompanyConditionInput
  ) {
    deleteEventCompany(input: $input, condition: $condition) {
      id
      name
      createdAt
      logo
      logoFileName
      email
      isDeleted
      eventLocationLookup {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      updatedAt
      event {
        items {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventClientAccess {
        items {
          id
          expiryDate
          clientPassword
          showPersonal
          description
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createEvent = /* GraphQL */ `
  mutation CreateEvent(
    $input: CreateEventInput!
    $condition: ModelEventConditionInput
  ) {
    createEvent(input: $input, condition: $condition) {
      id
      name
      code
      type
      requireDob
      iCalendar
      attendance
      status
      message
      description
      commsTemplate
      bloodDropStart
      bloodDropEnd
      urinePotLocation
      preQuestionTemplate
      clientPassword
      commsLink
      clientAccess
      registerInterest
      notifyRegisterInterest
      customAppointmentReminder
      reminderTime
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
      eventLocation {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventCollectUserData {
        items {
          id
          label
          questionType
          validation
          fieldType
          internalUse
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateEvent = /* GraphQL */ `
  mutation UpdateEvent(
    $input: UpdateEventInput!
    $condition: ModelEventConditionInput
  ) {
    updateEvent(input: $input, condition: $condition) {
      id
      name
      code
      type
      requireDob
      iCalendar
      attendance
      status
      message
      description
      commsTemplate
      bloodDropStart
      bloodDropEnd
      urinePotLocation
      preQuestionTemplate
      clientPassword
      commsLink
      clientAccess
      registerInterest
      notifyRegisterInterest
      customAppointmentReminder
      reminderTime
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
      eventLocation {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventCollectUserData {
        items {
          id
          label
          questionType
          validation
          fieldType
          internalUse
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteEvent = /* GraphQL */ `
  mutation DeleteEvent(
    $input: DeleteEventInput!
    $condition: ModelEventConditionInput
  ) {
    deleteEvent(input: $input, condition: $condition) {
      id
      name
      code
      type
      requireDob
      iCalendar
      attendance
      status
      message
      description
      commsTemplate
      bloodDropStart
      bloodDropEnd
      urinePotLocation
      preQuestionTemplate
      clientPassword
      commsLink
      clientAccess
      registerInterest
      notifyRegisterInterest
      customAppointmentReminder
      reminderTime
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
      eventLocation {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventCollectUserData {
        items {
          id
          label
          questionType
          validation
          fieldType
          internalUse
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createEventLocation = /* GraphQL */ `
  mutation CreateEventLocation(
    $input: CreateEventLocationInput!
    $condition: ModelEventLocationConditionInput
  ) {
    createEventLocation(input: $input, condition: $condition) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      eventLocationLookupId
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventSlotGroup {
        items {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateEventLocation = /* GraphQL */ `
  mutation UpdateEventLocation(
    $input: UpdateEventLocationInput!
    $condition: ModelEventLocationConditionInput
  ) {
    updateEventLocation(input: $input, condition: $condition) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      eventLocationLookupId
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventSlotGroup {
        items {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteEventLocation = /* GraphQL */ `
  mutation DeleteEventLocation(
    $input: DeleteEventLocationInput!
    $condition: ModelEventLocationConditionInput
  ) {
    deleteEventLocation(input: $input, condition: $condition) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      eventLocationLookupId
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventSlotGroup {
        items {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createEventLocationLookup = /* GraphQL */ `
  mutation CreateEventLocationLookup(
    $input: CreateEventLocationLookupInput!
    $condition: ModelEventLocationLookupConditionInput
  ) {
    createEventLocationLookup(input: $input, condition: $condition) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const updateEventLocationLookup = /* GraphQL */ `
  mutation UpdateEventLocationLookup(
    $input: UpdateEventLocationLookupInput!
    $condition: ModelEventLocationLookupConditionInput
  ) {
    updateEventLocationLookup(input: $input, condition: $condition) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const deleteEventLocationLookup = /* GraphQL */ `
  mutation DeleteEventLocationLookup(
    $input: DeleteEventLocationLookupInput!
    $condition: ModelEventLocationLookupConditionInput
  ) {
    deleteEventLocationLookup(input: $input, condition: $condition) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const createEventCollectUserData = /* GraphQL */ `
  mutation CreateEventCollectUserData(
    $input: CreateEventCollectUserDataInput!
    $condition: ModelEventCollectUserDataConditionInput
  ) {
    createEventCollectUserData(input: $input, condition: $condition) {
      id
      label
      questionType
      validation
      fieldType
      internalUse
      createdAt
      success
      error
      hint
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventCollectUserDataOptions {
        items {
          id
          options
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateEventCollectUserData = /* GraphQL */ `
  mutation UpdateEventCollectUserData(
    $input: UpdateEventCollectUserDataInput!
    $condition: ModelEventCollectUserDataConditionInput
  ) {
    updateEventCollectUserData(input: $input, condition: $condition) {
      id
      label
      questionType
      validation
      fieldType
      internalUse
      createdAt
      success
      error
      hint
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventCollectUserDataOptions {
        items {
          id
          options
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteEventCollectUserData = /* GraphQL */ `
  mutation DeleteEventCollectUserData(
    $input: DeleteEventCollectUserDataInput!
    $condition: ModelEventCollectUserDataConditionInput
  ) {
    deleteEventCollectUserData(input: $input, condition: $condition) {
      id
      label
      questionType
      validation
      fieldType
      internalUse
      createdAt
      success
      error
      hint
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventCollectUserDataOptions {
        items {
          id
          options
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createEventCollectUserDataOptions = /* GraphQL */ `
  mutation CreateEventCollectUserDataOptions(
    $input: CreateEventCollectUserDataOptionsInput!
    $condition: ModelEventCollectUserDataOptionsConditionInput
  ) {
    createEventCollectUserDataOptions(input: $input, condition: $condition) {
      id
      options
      isDeleted
      createdAt
      updatedAt
      eventCollectUserData {
        id
        label
        questionType
        validation
        fieldType
        internalUse
        createdAt
        success
        error
        hint
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
      }
    }
  }
`;
export const updateEventCollectUserDataOptions = /* GraphQL */ `
  mutation UpdateEventCollectUserDataOptions(
    $input: UpdateEventCollectUserDataOptionsInput!
    $condition: ModelEventCollectUserDataOptionsConditionInput
  ) {
    updateEventCollectUserDataOptions(input: $input, condition: $condition) {
      id
      options
      isDeleted
      createdAt
      updatedAt
      eventCollectUserData {
        id
        label
        questionType
        validation
        fieldType
        internalUse
        createdAt
        success
        error
        hint
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
      }
    }
  }
`;
export const deleteEventCollectUserDataOptions = /* GraphQL */ `
  mutation DeleteEventCollectUserDataOptions(
    $input: DeleteEventCollectUserDataOptionsInput!
    $condition: ModelEventCollectUserDataOptionsConditionInput
  ) {
    deleteEventCollectUserDataOptions(input: $input, condition: $condition) {
      id
      options
      isDeleted
      createdAt
      updatedAt
      eventCollectUserData {
        id
        label
        questionType
        validation
        fieldType
        internalUse
        createdAt
        success
        error
        hint
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
      }
    }
  }
`;
export const createEventSlotGroup = /* GraphQL */ `
  mutation CreateEventSlotGroup(
    $input: CreateEventSlotGroupInput!
    $condition: ModelEventSlotGroupConditionInput
  ) {
    createEventSlotGroup(input: $input, condition: $condition) {
      id
      room
      date
      capacity
      createdAt
      active
      isDeleted
      assignedTo
      updatedAt
      eventLocation {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventSlotGroup {
          nextToken
        }
      }
      eventSlot {
        items {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateEventSlotGroup = /* GraphQL */ `
  mutation UpdateEventSlotGroup(
    $input: UpdateEventSlotGroupInput!
    $condition: ModelEventSlotGroupConditionInput
  ) {
    updateEventSlotGroup(input: $input, condition: $condition) {
      id
      room
      date
      capacity
      createdAt
      active
      isDeleted
      assignedTo
      updatedAt
      eventLocation {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventSlotGroup {
          nextToken
        }
      }
      eventSlot {
        items {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteEventSlotGroup = /* GraphQL */ `
  mutation DeleteEventSlotGroup(
    $input: DeleteEventSlotGroupInput!
    $condition: ModelEventSlotGroupConditionInput
  ) {
    deleteEventSlotGroup(input: $input, condition: $condition) {
      id
      room
      date
      capacity
      createdAt
      active
      isDeleted
      assignedTo
      updatedAt
      eventLocation {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventSlotGroup {
          nextToken
        }
      }
      eventSlot {
        items {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createEventSlot = /* GraphQL */ `
  mutation CreateEventSlot(
    $input: CreateEventSlotInput!
    $condition: ModelEventSlotConditionInput
  ) {
    createEventSlot(input: $input, condition: $condition) {
      id
      time
      length
      type
      booked
      isDeleted
      createdAt
      updatedAt
      eventSlotGroup {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        updatedAt
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        eventSlot {
          nextToken
        }
      }
      eventBooking {
        items {
          id
          firstname
          lastname
          email
          mobile
          dob
          customData
          createdAt
          startTime
          twentyFourHourReminder
          fortyEightHourReminder
          customReminder
          attendance
          searchField
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteEventSlot = /* GraphQL */ `
  mutation DeleteEventSlot(
    $input: DeleteEventSlotInput!
    $condition: ModelEventSlotConditionInput
  ) {
    deleteEventSlot(input: $input, condition: $condition) {
      id
      time
      length
      type
      booked
      isDeleted
      createdAt
      updatedAt
      eventSlotGroup {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        updatedAt
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        eventSlot {
          nextToken
        }
      }
      eventBooking {
        items {
          id
          firstname
          lastname
          email
          mobile
          dob
          customData
          createdAt
          startTime
          twentyFourHourReminder
          fortyEightHourReminder
          customReminder
          attendance
          searchField
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createEventCommsTemplate = /* GraphQL */ `
  mutation CreateEventCommsTemplate(
    $input: CreateEventCommsTemplateInput!
    $condition: ModelEventCommsTemplateConditionInput
  ) {
    createEventCommsTemplate(input: $input, condition: $condition) {
      id
      name
      emailSubject
      reminderEmailSubject
      emailTemplate
      reminderEmailTemplate
      smsReminderTemplate
      smsTemplate
      isDeleted
      createdAt
      updatedAt
      eventCommsTemplateAttachments {
        items {
          id
          attachment
          key
          name
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateEventCommsTemplate = /* GraphQL */ `
  mutation UpdateEventCommsTemplate(
    $input: UpdateEventCommsTemplateInput!
    $condition: ModelEventCommsTemplateConditionInput
  ) {
    updateEventCommsTemplate(input: $input, condition: $condition) {
      id
      name
      emailSubject
      reminderEmailSubject
      emailTemplate
      reminderEmailTemplate
      smsReminderTemplate
      smsTemplate
      isDeleted
      createdAt
      updatedAt
      eventCommsTemplateAttachments {
        items {
          id
          attachment
          key
          name
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteEventCommsTemplate = /* GraphQL */ `
  mutation DeleteEventCommsTemplate(
    $input: DeleteEventCommsTemplateInput!
    $condition: ModelEventCommsTemplateConditionInput
  ) {
    deleteEventCommsTemplate(input: $input, condition: $condition) {
      id
      name
      emailSubject
      reminderEmailSubject
      emailTemplate
      reminderEmailTemplate
      smsReminderTemplate
      smsTemplate
      isDeleted
      createdAt
      updatedAt
      eventCommsTemplateAttachments {
        items {
          id
          attachment
          key
          name
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createEventCommsTemplateAttachments = /* GraphQL */ `
  mutation CreateEventCommsTemplateAttachments(
    $input: CreateEventCommsTemplateAttachmentsInput!
    $condition: ModelEventCommsTemplateAttachmentsConditionInput
  ) {
    createEventCommsTemplateAttachments(input: $input, condition: $condition) {
      id
      attachment
      key
      name
      isDeleted
      createdAt
      updatedAt
      EventCommsTemplate {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        isDeleted
        createdAt
        updatedAt
        eventCommsTemplateAttachments {
          nextToken
        }
      }
    }
  }
`;
export const updateEventCommsTemplateAttachments = /* GraphQL */ `
  mutation UpdateEventCommsTemplateAttachments(
    $input: UpdateEventCommsTemplateAttachmentsInput!
    $condition: ModelEventCommsTemplateAttachmentsConditionInput
  ) {
    updateEventCommsTemplateAttachments(input: $input, condition: $condition) {
      id
      attachment
      key
      name
      isDeleted
      createdAt
      updatedAt
      EventCommsTemplate {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        isDeleted
        createdAt
        updatedAt
        eventCommsTemplateAttachments {
          nextToken
        }
      }
    }
  }
`;
export const deleteEventCommsTemplateAttachments = /* GraphQL */ `
  mutation DeleteEventCommsTemplateAttachments(
    $input: DeleteEventCommsTemplateAttachmentsInput!
    $condition: ModelEventCommsTemplateAttachmentsConditionInput
  ) {
    deleteEventCommsTemplateAttachments(input: $input, condition: $condition) {
      id
      attachment
      key
      name
      isDeleted
      createdAt
      updatedAt
      EventCommsTemplate {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        isDeleted
        createdAt
        updatedAt
        eventCommsTemplateAttachments {
          nextToken
        }
      }
    }
  }
`;
export const createEventClientAccess = /* GraphQL */ `
  mutation CreateEventClientAccess(
    $input: CreateEventClientAccessInput!
    $condition: ModelEventClientAccessConditionInput
  ) {
    createEventClientAccess(input: $input, condition: $condition) {
      id
      expiryDate
      clientPassword
      showPersonal
      description
      createdAt
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const updateEventClientAccess = /* GraphQL */ `
  mutation UpdateEventClientAccess(
    $input: UpdateEventClientAccessInput!
    $condition: ModelEventClientAccessConditionInput
  ) {
    updateEventClientAccess(input: $input, condition: $condition) {
      id
      expiryDate
      clientPassword
      showPersonal
      description
      createdAt
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const deleteEventClientAccess = /* GraphQL */ `
  mutation DeleteEventClientAccess(
    $input: DeleteEventClientAccessInput!
    $condition: ModelEventClientAccessConditionInput
  ) {
    deleteEventClientAccess(input: $input, condition: $condition) {
      id
      expiryDate
      clientPassword
      showPersonal
      description
      createdAt
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const updateBookingError = /* GraphQL */ `
  mutation UpdateBookingError(
    $input: UpdateBookingErrorInput!
    $condition: ModelBookingErrorConditionInput
  ) {
    updateBookingError(input: $input, condition: $condition) {
      id
      error
      payload
      browser
      createdAt
      updatedAt
    }
  }
`;
export const deleteBookingError = /* GraphQL */ `
  mutation DeleteBookingError(
    $input: DeleteBookingErrorInput!
    $condition: ModelBookingErrorConditionInput
  ) {
    deleteBookingError(input: $input, condition: $condition) {
      id
      error
      payload
      browser
      createdAt
      updatedAt
    }
  }
`;
export const updateEventSlot = /* GraphQL */ `
  mutation UpdateEventSlot(
    $input: UpdateEventSlotInput!
    $condition: ModelEventSlotConditionInput
  ) {
    updateEventSlot(input: $input, condition: $condition) {
      id
      time
      length
      type
      booked
      isDeleted
      createdAt
      updatedAt
      eventSlotGroup {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        updatedAt
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        eventSlot {
          nextToken
        }
      }
      eventBooking {
        items {
          id
          firstname
          lastname
          email
          mobile
          dob
          customData
          createdAt
          startTime
          twentyFourHourReminder
          fortyEightHourReminder
          customReminder
          attendance
          searchField
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createEventBooking = /* GraphQL */ `
  mutation CreateEventBooking(
    $input: CreateEventBookingInput!
    $condition: ModelEventBookingConditionInput
  ) {
    createEventBooking(input: $input, condition: $condition) {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      customReminder
      attendance
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        eventBooking {
          nextToken
        }
      }
    }
  }
`;
export const updateEventBooking = /* GraphQL */ `
  mutation UpdateEventBooking(
    $input: UpdateEventBookingInput!
    $condition: ModelEventBookingConditionInput
  ) {
    updateEventBooking(input: $input, condition: $condition) {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      customReminder
      attendance
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        eventBooking {
          nextToken
        }
      }
    }
  }
`;
export const deleteEventBooking = /* GraphQL */ `
  mutation DeleteEventBooking(
    $input: DeleteEventBookingInput!
    $condition: ModelEventBookingConditionInput
  ) {
    deleteEventBooking(input: $input, condition: $condition) {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      customReminder
      attendance
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        eventBooking {
          nextToken
        }
      }
    }
  }
`;
export const createBookingError = /* GraphQL */ `
  mutation CreateBookingError(
    $input: CreateBookingErrorInput!
    $condition: ModelBookingErrorConditionInput
  ) {
    createBookingError(input: $input, condition: $condition) {
      id
      error
      payload
      browser
      createdAt
      updatedAt
    }
  }
`;
